module.exports = __webpack_public_path__ + "img/logo.3306334e.jpg";